import { render, staticRenderFns } from "./k-tag-simple.vue?vue&type=template&id=676505c2&"
import script from "./k-tag-simple.vue?vue&type=script&lang=js&"
export * from "./k-tag-simple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports